// src/public/rsvp/utils/rsvpFormatters.js
export function safeText(v, fallback = '—') {
  const s = (v ?? '').toString().trim();
  return s.length ? s : fallback;
}

export function fmtDateTR(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('tr-TR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function fmtTimeTR(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
}

export function toneForAttendance(status) {
  if (status === 'YES' || status === 'PRESENT') return 'success';
  if (status === 'NO' || status === 'ABSENT' || status === 'CANCELLED' || status === 'BURNED')
    return 'error';
  if (status === 'PENDING' || status === 'UNKNOWN') return 'warning';
  return 'info';
}
